import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, RadioGroupProps } from '@mui/material';

type RadioGroup = {
  type: 'radioGroup';
  name: string;
  radios: Array<{ id: number; name: string }>;
  rule?: RegisterOptions;
};

type RadioGroupPartialProps = Omit<RadioGroupProps, keyof RadioGroup>;

export type CustomRadioGroupProp = RadioGroup & RadioGroupPartialProps;

const CustomRadioGroup: React.FC<RadioGroup & RadioGroupPartialProps> = ({
  name,
  radios,
  rule,
  ...RadioGroupProps
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rule}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <RadioGroup row value={field.value} name={name} {...RadioGroupProps}>
            {radios.map((element, index) => {
              return (
                <FormControlLabel {...field} key={index} value={element.id} control={<Radio />} label={element.name} />
              );
            })}
          </RadioGroup>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default CustomRadioGroup;
